import * as v from 'valibot';

// NOTE: mirrors CommandCenterMap-BE `EventTemplateDto`
// (src/app/http/admin/admin-events.service.ts) — keep the two in sync. Every DTO
// field MUST be declared: v.object strips undeclared keys silently.
export const eventTemplateSchema = v.object({
  /** The captured fixture's basename. What a fire POSTs back to identify it. */
  id: v.pipe(v.string(), v.minLength(1)),
  eventType: v.pipe(v.string(), v.minLength(1)),
  /** A REAL clinical case identifier — these are captured messages, not fakes. */
  caseName: v.string(),
  /**
   * Whether the fixture's own eventData carries an `operationDateTime`, which is
   * the first source the consumer dates the event from. False means the event is
   * dated from the regenerated UUIDv7 `eventId` instead, i.e. from the moment of
   * the fire — which is the difference the workbench has to show, because a
   * fired template landing at the template's own date looks like nothing happened.
   */
  hasOperationDateTime: v.boolean(),
});

export const eventTemplatesResponseSchema = v.object({
  data: v.array(eventTemplateSchema),
  dataGeneratedAt: v.nullable(v.string()),
  errors: v.nullable(v.array(v.unknown())),
  expires: v.nullable(v.string()),
  errorsGeneratedAt: v.nullable(v.string()),
});

/** The reply to a fire: the `eventId` the BE minted for this one. */
export const injectedEventSchema = v.object({
  eventId: v.pipe(v.string(), v.minLength(1)),
});
